import { AnyAction } from 'redux';
import { actionTypes } from '../common/constants/actionTypes';

export interface IHttpState {
  callCount: number;
  inProgress: boolean;
}

const initialState: IHttpState = {
  callCount: 0,
  inProgress: false,
};

export const httpReducer = (
  state: IHttpState = initialState,
  action: AnyAction
): IHttpState => {
  switch (action.type) {
    case actionTypes.HTTP_CALL_START: {
      const callCount = state.callCount + 1;
      return { callCount, inProgress: true };
    }

    case actionTypes.HTTP_CALL_END: {
      const callCount = Math.max(0, state.callCount - 1);
      return { callCount, inProgress: callCount > 0 };
    }

    // Optional:
    // case actionTypes.HTTP_CALL_RESET:
    //   return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/http.ts